var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 51,
    viewBox: "0 0 2 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag colors divider"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624177",
    y: 35.0625,
    width: 1.15909,
    height: 15.9375,
    fill: "#1D2021",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624178",
    y: 17.5312,
    width: 1.15909,
    height: 15.9375,
    fill: "#1D2021",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624179",
    width: 1.15909,
    height: 15.9375,
    fill: "#1D2021",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLess);
export default __webpack_public_path__ + "static/media/flag_less.2f63a505be3fb35d0e854c0aa6c58be7.svg";
export { ForwardRef as ReactComponent };